import Axios from "./index";
import { parseFilters } from "./helper";

export const indexPlaylists = params => {
  return Axios.get(`/user/playlists`, {
    params: parseFilters(params)
  });
};

export const createPlaylist = playlistParams => {
  return Axios.post(`/user/playlists`, playlistParams);
};

export const showPlaylist = playlist_id => {
  return Axios.get(`/user/playlists/${playlist_id}`);
};

export const updatePlaylist = playlistParams => {
  return Axios.put(
    `/user/playlists/${playlistParams.playlist.id}`,
    playlistParams
  );
};

export const deletePlaylist = playlist_id => {
  return Axios.delete(`/user/playlists/${playlist_id}`);
};

export const indexPlaylistMedia = (playlist_id, params = {}) => {
  return Axios.get(`/user/playlists/${playlist_id}/playlists_media`, {
    params
  });
};

export const addMediumToPlaylist = (playlist_id, params = {}) => {
  return Axios.post(`/user/playlists/${playlist_id}/playlists_media`, params);
};

export const removeMediumFromPlaylist = (playlist_id, medium_id) => {
  return Axios.delete(
    `/user/playlists/${playlist_id}/playlists_media?medium_id=${medium_id}`
  );
};
